import { gallectionListSchema } from '@wix/da-shared-react/pkg/redux/normalizr/schemas/folder';
import { useNormalizedStream } from '@wix/da-shared-react/pkg/utils/hooks/useStream';
import { STUDIO_BOOKMARKS_STREAM } from '../../constants';

export function useBookmarksStream() {
  return useNormalizedStream(STUDIO_BOOKMARKS_STREAM.streamId, gallectionListSchema);
}

export default useBookmarksStream;
